/*** Autogenerated. Use 'npm run generate-sources' to regenerate. ***/
import {RxJsonObject} from '../../../types/json/RxJsonObject';
import {JSONSchema4} from 'json-schema';
import {generateConverterToRx} from '../../../helpers/db/converters/generateConverterToRx';
import {generateArrayConverter} from '../../../helpers/db/converters/generateArrayConverter';
import {isDescribedByJsonSchema} from '../../../types/guards/isDescribedByJsonSchema';
import {isPartiallyDescribedByJsonSchema} from '../../../types/guards/isPartiallyDescribedByJsonSchema';
/**
 * Collection `configurations` contains documents of `RxConfiguration` type.
 */
export interface RxConfiguration {
  /**
   * Primary key.
   */
  id: string;
  redapp_name: string;
  configuration_name: string;
  value: string;
  description: string;
  /**
   * Special property. Property indicates if given document is active and should be used in application. Document with this property set to `false` should be considered as non-existing.
   */
  active__document?: boolean;
}
export const RxConfigurationSchema: JSONSchema4 = {
    title: 'RxConfiguration',
    primaryKey: 'id',
    required: [
        'id',
        'redapp_name',
        'configuration_name',
        'value',
        'description',
    ],
    version: 0,
    type: 'object',
    properties: {
        id: {
            maxLength: 10000,
            type: 'string',
            description: 'Primary key.',
        },
        redapp_name: {
            type: 'string',
            description: '',
        },
        configuration_name: {
            type: 'string',
            description: '',
        },
        value: {
            type: 'string',
            description: '',
        },
        description: {
            type: 'string',
            description: '',
        },
        active__document: {
            type: 'boolean',
            default: false,
            description: 'Special property. Property indicates if given document is active and should be used in application. Document with this property set to `false` should be considered as non-existing.',
        },
    },
    additionalProperties: false,
    description: 'Collection `configurations` contains documents of `RxConfiguration` type.',
}
export const asRxConfiguration = generateConverterToRx<RxConfiguration>(RxConfigurationSchema, 'RxConfigurationSchema');
export const asRxConfigurationArray = generateArrayConverter<RxConfiguration>(asRxConfiguration);
export function instanceOfRxConfiguration(o?: any): o is RxConfiguration { 
    return isDescribedByJsonSchema(o, RxConfigurationSchema, false, false); 
}
export function isRxConfiguration(o?: any): o is RxConfiguration { 
    return isDescribedByJsonSchema(o, RxConfigurationSchema, false, false); 
}
export function instanceOfPartialRxConfiguration(o?: any): o is Partial<RxConfiguration> { 
    return isPartiallyDescribedByJsonSchema(o, RxConfigurationSchema);
}
export function isPartialRxConfiguration(o?: any): o is Partial<RxConfiguration> { 
    return isPartiallyDescribedByJsonSchema(o, RxConfigurationSchema); 
}